module.exports = __webpack_public_path__ + "static/media/corona.8bdfeecb.png";